import { ModelConverter as BaseModelConverter } from 'lib/domain/model/ModelConverter';
import { HttpPersistence } from 'lib/persistence/http/HttpPersistence';

import {
	GeneratorModelConverter as ModelConverter,
	GeneratorPersistenceModel as PersistenceModel,
	GeneratorStoreModel as StoreModel,
	GeneratorViewModel as ViewModel,
	CreatableGeneratorViewModel as CreatableViewModel
} from 'services/nuclide/domain/model/GeneratorModel';

export class GeneratorHttpPersistence extends HttpPersistence<PersistenceModel, StoreModel, ViewModel, CreatableViewModel> {

	protected serviceApiControllerUri = 'generator/api/v1';
	protected collectionControllerUri = 'generators';
	protected entityControllerUri = 'generator';

	protected responseCollectionKey = 'GeneratorModelCollection';
	protected responseEntityKey = 'GeneratorModel';

	protected modelConverter: BaseModelConverter<PersistenceModel, StoreModel, ViewModel, CreatableViewModel> = new ModelConverter();

}
